import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { Get } from "../../Common/WebRequest";
import { getStorageItem } from "../../Common/Utility";
import "./UserProfilePermissions.css";

export default function UserProfilePermissions() {
  const [regions, setRegions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setError("");
      setLoading(true);
      const loginUserName = await getStorageItem("login", "userName");
      if (!loginUserName) {
        setLoading(false);
        setError("Nicht angemeldet.");
        return;
      }
      const res = await Get(
        `UserProfile/UserPermissionsForProfile/${encodeURIComponent(loginUserName)}`
      );
      setLoading(false);
      if (res?.isSuccess && res?.result?.regions) {
        setRegions(res.result.regions);
      } else {
        setRegions([]);
        const msg =
          res?.displayMessage ||
          res?.Error ||
          "Berechtigungen konnten nicht geladen werden.";
        setError(msg);
      }
    })();
  }, []);

  if (loading) {
    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Wird geladen...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle1" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (!regions.length) {
    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" gutterBottom>
        Meine Regionen & Branchen
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Keine Regionen oder Branches zugewiesen.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
      Meine Regionen & Branchen
      </Typography>
      <Box className="user-profile-permissions-tree">
        {regions.map((region) => (
          <Box key={region.id} className="user-profile-permissions-region">
            <Typography
              component="div"
              variant="subtitle1"
              className="user-profile-permissions-region-name"
            >
              {region.regionName}
            </Typography>
            <Box className="user-profile-permissions-branches">
              {(region.branches || []).map((branch) => (
                <Typography
                  key={branch.id}
                  component="div"
                  variant="body2"
                  className="user-profile-permissions-branch-name"
                >
                  {branch.branchName}
                </Typography>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
